import { render, staticRenderFns } from "./AddFollowup.vue?vue&type=template&id=33008c47&scoped=true"
import script from "./AddFollowup.vue?vue&type=script&lang=js"
export * from "./AddFollowup.vue?vue&type=script&lang=js"
import style0 from "./AddFollowup.vue?vue&type=style&index=0&id=33008c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33008c47",
  null
  
)

export default component.exports